<template>
  <div class="item-box-content">
    <div class="title-font-style">
      <span>待配货清单</span>
    </div>
    <div style="margin-top:20px">
      <el-table
        border
        max-height="378"
        ref="tableRef"
        :data="allocatedListArray"
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" v-show="$route.query.stockUpType === '入库备货'" width="55"></el-table-column>
        <el-table-column prop="orderContractStockupVo.brandName" show-overflow-tooltip label="品牌"></el-table-column>
        <el-table-column prop="orderContractStockupVo.seriesName" show-overflow-tooltip label="系列"></el-table-column>
        <el-table-column prop="orderContractStockupVo.proName" show-overflow-tooltip label="产品名称"></el-table-column>
        <el-table-column prop="orderContractStockupVo.proType" show-overflow-tooltip label="型号">
          <template slot-scope="scope">
            <div
              class="approval line-limit-length"
              @click="onEdit(scope.row.orderContractStockupVo)"
            >{{ scope.row.orderContractStockupVo.proType }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="orderContractStockupVo.orderNumber"
          show-overflow-tooltip
          label="订货号"
        ></el-table-column>
        <el-table-column prop="orderContractStockupVo.cbUnit" show-overflow-tooltip label="单位"></el-table-column>
        <el-table-column prop="orderContractStockupVo.count" show-overflow-tooltip label="备货数量">
          <template slot-scope="scope">
            {{
            +scope.row.orderContractStockupVo.countAll -
            +scope.row.orderContractStockupVo.countUsed - +scope.row.orderContractStockupVo.countUsedAllot
            }}
          </template>
        </el-table-column>
        <el-table-column prop="orderContractStockupVo.cbPrice" show-overflow-tooltip label="采购单价">
          <template slot-scope="scope">
            {{
            scope.row.orderContractStockupVo.cbPrice | priceFilterNum
            }}
          </template>
        </el-table-column>
        <el-table-column prop label="采购总额">
          <template slot-scope="scope">
            {{
            ((+scope.row.orderContractStockupVo.countAll -
            +scope.row.orderContractStockupVo.countUsed - +scope.row.orderContractStockupVo.countUsedAllot) *
            scope.row.orderContractStockupVo.cbPrice)| priceFilterNum
            }}
          </template>
        </el-table-column>
        <el-table-column prop="orderContractStockupVo.cbPriceSource" label="询价来源">
          <template slot-scope="scope">
            {{
            cbPriceSource[
            scope.row.orderContractStockupVo.cbPriceSource - 1
            ]
            }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="orderContractStockupVo.suName" label="供应商"></el-table-column>
        <el-table-column
          prop="orderContractStockupVo.cbExtimeValue"
          show-overflow-tooltip
          label="货期"
        >
          <template slot-scope="scope">
            <div class="line-limit-length">{{scope.row.orderContractStockupVo.cbExtimeValue+'天'}}</div>
          </template>
        </el-table-column>
        <el-table-column
          v-if="$route.query.stockUpType === '入库备货'"
          prop="orderContractStockupVo.stockNum"
          label="在库可备货总数"
          width="120px"
        >
          <template
            slot-scope="scope"
          >{{scope.row.orderContractStockupVo.stockNum-scope.row.orderContractStockupVo.countUsed}}</template>
        </el-table-column>
        <el-table-column v-if="$route.query.stockUpType === '入库备货'" label="库存详情">
          <template slot-scope="scope">
            <el-button
              type="text"
              :disabled="scope.row.orderContractStockupVo.stockNum === 0"
              @click="detail(scope.row, scope.$index)"
            >操作</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-row style="margin-top:20px">
        <el-col :span="24">
          <span>快捷配货：</span>
          <el-button
            v-if="$route.query.stockUpType === '入库备货'"
            type="primary"
            plain
            @click="onMovedIntoWarehouse"
          >批量库存备货</el-button>
          <el-button
            v-if="$route.query.stockUpType === '直发备货'"
            type="primary"
            plain
            @click="onMovedIntoPurchaseAll"
          >全部采购备货</el-button>
          <el-button
            v-if="$route.query.stockUpType === '入库备货'"
            type="primary"
            plain
            @click="onMovedIntoPurchase"
          >批量采购备货</el-button>
        </el-col>
        <el-col
          :span="24"
          v-if="$route.query.stockUpType === '入库备货'"
          style="color:#4e555b;padding-bottom:20px;padding-top:20px;"
        >
          批量库存备货 :
          所选产品将优先调用备货仓库中可用产品进行备货，数量不足时移入采购备货区，不做异地仓调拨处理；
          <br />批量采购备货 : 所选产品直接移入采购备货区，不调用仓库库存备货；
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { formatDate } from '@/util/tool'
export default {
  props: ['allocatedList'],
  components: {
  },
  data () {
    return {
      allocatedListArray: [],
      checkedArray: [], // 多选选中数组
      cbPriceSource: ['系统', '人工', '特价审批', '其他', '库存']
    }
  },
  watch: {
    allocatedList: {
      handler (newVal) {
        this.allocatedListArray = newVal
      },
      deep: true
    }
  },
  mounted () { },
  methods: {
    // 点击操作右侧dawer打开
    detail (row, index) {
      this.$emit('detailDrawer', row, index)// 把单行数据和索引传过去
    },
    onInitial (val) { },
    // 多选
    handleSelectionChange (val) {
      this.checkedArray = val // 选中的数据
    },
    // 入库批量库存备货
    onMovedIntoWarehouse () {
      this.$emit('onMovedIntoWarehouse', this.checkedArray)
    },

    // 入库批量采购备货
    onMovedIntoPurchase () {
      this.$emit('onMovedIntoPurchase', this.checkedArray)
      this.checkedArray = []
    },

    // 直发全部采购备货
    onMovedIntoPurchaseAll () {
      this.$emit('onMovedIntoPurchaseAll', this.allocatedListArray)
    },
    onEdit (row) {
      this.$router.push({
        name: 'productDetails',
        query: { id: row.proId }
      })
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    }
  },
  filters: {
    dateFilter
  }
}
function dateFilter (time) {
  if (time === null) {
    return ''
  } else {
    const date = new Date(time)
    return formatDate(date, 'yyyy-MM-dd hh:mm')
  }
}
</script>
<style lang="scss" scoped>
</style>
